//@ts-nocheck
import { Grid, Link } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import pilotImage from "../../../assets/images/pilot/pilot_mode.png";
import pilotImageMobile from "../../../assets/images/pilot/pilot_mode_mobile.png";
import loginIcon from "../../../assets/images/pilot/Vector.png";
import logoDefault from "./../../../assets/images/dxcbrand.png";
import "./../../../styles/scss/common.scss";
import "./pilotMode.scss";
import parse from 'html-react-parser';
import Box from "../Box";

const Pilotmode = (props) => {
  const { logoImg, LoginPath, pilotImage1, pilotImage2, content } = props;
  let imageChange = pilotImage2;

  if(window.screen.width <= 607){
    imageChange = pilotImage1;
  }

  const HandleLogin = () =>{
    localStorage.clear();
    window.location.href = LoginPath;
  };

  return (
    <>
      <div className="top-nav-my-tech">
        <div className="outer wrapper-container">
          <div className="content-left">
            <div className="logo">
              <Link href="/">
                {logoImg? (<img src={logoImg} alt="uptime" title="uptime" />):(<img src={logoDefault} alt="uptime" title="uptime" />)}
              </Link>
            </div>
          </div>
          <div className="content-right">
            <div className="icon-login">
              <Link href={LoginPath} onClick={HandleLogin}>
                <img src={loginIcon} alt="logo" title="logo" />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="pilot-container">
        <Box
          maxWidth={{
            xxl: '1440px',
          }}
          margin={{
            xxl: '0 auto',
          }}
          padding={{
            xxs: '42px 17px 113px 17px',
            xs: '42px 17px 113px 17px',
            sm: '38px 24px 114px 24px',
            md: '38px 24px 114px 24px',
            lg: '40px 152px 152px 152px',
            xl: '40px 152px 152px 152px',
            xxl: '0',
          }}>
          <Grid item container direction="row">
            <Grid item xs={8} className="pilot-grid-left">
              <div className="pilot-image">
                <img src={imageChange} alt="bannerImg" title="Banner" />
              </div>
            </Grid>
            <Grid item xs={4} className="pilot-grid-right">
              <div className="pilot-box">
                {!!content && parse(content)}
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  )
};

Pilotmode.propTypes = {
  logoImg: PropTypes.string,
  LoginPath: PropTypes.string,
  pilotImage1: PropTypes.string,
  pilotImage2: PropTypes.string,
  content: PropTypes.object
};

Pilotmode.defaultProps = {
  logoImg: '',
  pilotImage1: pilotImageMobile,
  pilotImage2:pilotImage,
  LoginPath: '/login',
  content: ''
};

export default Pilotmode;
